module.exports = __webpack_public_path__ + "static/img/moreInfo1.5133bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ceramide/moreInfo1.png
// module id = 8rvY
// module chunks = 1